import React, { useEffect, useState } from "react";
import adminAccountingApi from "../services/adminAccountingApi";
import "../styles/Admin.css";

export default function AdminPnLPage({ adminEmail, onLogout }) {
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [pnl, setPnl] = useState({ revenue: 0, expenses: 0, netProfit: 0 });
  const [loading, setLoading] = useState(false);

  async function load() {
    setStatus({ type: "", msg: "" });
    setLoading(true);
    try {
      const res = await adminAccountingApi.getPnL({
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
      });
      if (!res?.ok) throw new Error(res?.error || "load_failed");
      setPnl({ revenue: res.revenue || 0, expenses: res.expenses || 0, netProfit: res.netProfit || 0 });
    } catch {
      setStatus({ type: "error", msg: "Unable to load P&L." });
      setPnl({ revenue: 0, expenses: 0, netProfit: 0 });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function money(v) {
    const n = Number(v || 0);
    return Number.isFinite(n) ? n.toFixed(2) : "0.00";
  }

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-admin-page">
        <div className="ucx-admin-header">
          <div>
            <h1 className="ucx-admin-title">Profit & Loss</h1>
            <p className="ucx-admin-subtitle">Revenue minus expenses</p>
          </div>

          <div className="ucx-admin-header-right">
            {adminEmail && <span className="ucx-small">Signed in as {adminEmail}</span>}
            <div className="ucx-admin-header-actions">
              <button className="ucx-btn ucx-btn-outline" type="button" onClick={load} disabled={loading}>
                {loading ? "Refreshing…" : "Refresh"}
              </button>
              {typeof onLogout === "function" ? (
                <button type="button" className="ucx-admin-btn ucx-admin-btn-reject" onClick={onLogout}>
                  Sign out
                </button>
              ) : null}
            </div>
          </div>
        </div>

      <div className="ucx-admin-panel">
          <div className="ucx-admin-panel-title">Filters</div>
          <div className="ucx-admin-filters ucx-admin-filters-inventory">
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} title="Date From" />
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} title="Date To" />
            <button className="ucx-btn ucx-btn-primary" type="button" onClick={load} disabled={loading}>
              Apply
            </button>
          </div>
          {status.type === "error" ? <div className="ucx-admin-status-error">{status.msg}</div> : null}
        </div>

      <div className="ucx-admin-panel">
          <div className="ucx-admin-panel-title">Summary</div>
          <div className="ucx-admin-form-grid ucx-admin-form-grid-2">
            <div className="ucx-admin-field">
              <label>Revenue</label>
              <input value={money(pnl.revenue)} readOnly />
            </div>
            <div className="ucx-admin-field">
              <label>Expenses</label>
              <input value={money(pnl.expenses)} readOnly />
            </div>
            <div className="ucx-admin-field" style={{ gridColumn: "1 / -1" }}>
              <label>Net Profit</label>
              <input value={money(pnl.netProfit)} readOnly />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
